import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=3812b84a&scoped=true&"
import script from "./imagePreview.vue?vue&type=script&lang=ts&"
export * from "./imagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./imagePreview.vue?vue&type=style&index=0&id=3812b84a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812b84a",
  null
  
)

export default component.exports